<template>
  <div class="c-image-container">
    <img class="c-image" :src="item" :key="item" v-for="item in imgItems">
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-images',
    props: {
      imgItems: {
        required: true,
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?a3b4b026